#import "../fragments/sales-automation-stageset.graphql"

mutation UpdateClosedLeadEmailAutomation(
    $emailAutomation: UpdateClosedLeadEmailAutomationInputFieldInput!
) {
    updateClosedLeadEmailAutomation(input: {emailAutomation: $emailAutomation}) {
        stageset {
            ...SalesAutomationStageset
        }
    }
}
